import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TokenService } from '../services/common/token.service';
import { BaseService } from '../services/common/base.service';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DepartmentDashboardService extends BaseService {

  protected http: HttpClient;

  constructor(http: HttpClient, tokenService: TokenService) {
    super(tokenService);
    this.http = http;
  }

  GetDepartmentDashboard(userId: String, appType: String, financialyear: String, AppCount: String) {
    // return this.http.get<any>(`${environment.apiUrl}DashBoard/GetFarmerApplicationForApproval?UserId=${userId}`, { headers: this.buildHeadersNew() });
    return this.http.get<any>(`${environment.apiUrl}DashBoard/GetFarmerApplicationForApproval?UserId=${userId}&AppType=${appType}&financialyear=${financialyear}&AppCount=${AppCount}`);
  }


  GetStatusMaster(userId, actionId) {
    // return this.http.get<any>(`${environment.apiUrl}DashBoard/GetStatusMaster?Userid=${userId}&ActionId=${actionId}`, { headers: this.buildHeaders() });
    return this.http.get<any>(`${environment.apiUrl}DashBoard/GetStatusMaster?Userid=${userId}&ActionId=${actionId}`);
  }
  GetSubsidaryDetails(userId) {
    // return this.http.get<any>(`${environment.apiUrl}DashBoard/GetStatusMaster?Userid=${userId}&ActionId=${actionId}`, { headers: this.buildHeaders() });
    return this.http.get<any>(`${environment.apiUrl}Reports/GetMIBeneficiaryReport?UserId=${userId}`);
  }
  GetVendorSubsidaryDetails(userId,userType) {
    // return this.http.get<any>(`${environment.apiUrl}DashBoard/GetStatusMaster?Userid=${userId}&ActionId=${actionId}`, { headers: this.buildHeaders() });
    return this.http.get<any>(`${environment.apiUrl}Reports/GetMIBeneficiaryReport?UserId=${userId}&userType=${userType}`);
  }

  getStatusMasterEPC(userId) {
    return this.http.get<any>(`${environment.apiUrl}DashBoard/GetStatusMasterEPC?Userid=${userId}`);
  }

  getJEUserIds(userId) {
    return this.http.get<any>(`${environment.apiUrl}Department/GetJEUserIds?UserId=${userId}`);
  }

  InsertFarmerApplicationApprovalRemarks(reqBody: any) {
    // return this.http.post(`${environment.apiUrl}DashBoard/InsertFarmerApplicationApprovalRemarks?AppId=${appId}&Userid=${userId}&Remarks=${remarks}&Status=${statusValue}`, { headers: this.buildHeaders() }, {responseType: 'text'});
    return this.http.post(`${environment.apiUrl}DashBoard/InsertFarmerApplicationApprovalRemarks`, reqBody);
  }

  getVendorMIEstimationsForApproval(userId, actionType, financialyear) {
    // return this.http.get<any>(`${environment.apiUrl}DashBoard/GetVendorMIEstimateForApproval?UserId=${userId}`, { headers: this.buildHeaders() });
    return this.http.get<any>(`${environment.apiUrl}DashBoard/GetVendorMIEstimateForApproval?UserId=${userId}&AppType=${actionType}&financialyear=${financialyear}`);
  }

  getVendorMIEstimation(appId, vendorRegId, progId) {
    // return this.http.get<any>(`${environment.apiUrl}DashBoard/GetVendorMIEstimation?AppId=${appId}&VendorRegId=${vendorRegId}&ProgID=${progId}`, { headers: this.buildHeaders() });
    return this.http.get<any>(`${environment.apiUrl}DashBoard/GetVendorMIEstimation?AppId=${appId}&VendorRegId=${vendorRegId}&ProgID=${progId}`);
  }

  getVendorMIBOQ(appId, vendorRegId, progId){
    return this.http.get<any>(`${environment.apiUrl}DashBoard/GetVendorMIBOQ?AppId=${appId}&VendorRegId=${vendorRegId}&ProgId=${progId}`);
  }

  insertVendorMIEstimateForApproval(reqBody: any) {
    // return this.http.get<any>(`${environment.apiUrl}DashBoard/InsertVendorMIEstimateForApproval?AppId=${appId}&Userid=${userId}&Remarks=${remarks}`, { headers: this.buildHeaders() });
    return this.http.post(`${environment.apiUrl}DashBoard/InsertVendorMIEstimateForApproval`, reqBody);
  }


  workFlowAllStatus(appId: string){
    return this.http.get<any>(`${environment.apiUrl}Vendor/WorkFlowAllStatus?AppID=${appId}`);
  }
  
  
  dashboardSummaryReport(financialYear: any){
    return this.http.get<any>(`${environment.apiUrl}Reports/DashboardSummaryReport?financialyear=${financialYear}`);
  }

  printMultipleChallanAtal(reqBody){
    return this.http.post(`${environment.apiUrl}Challan/PrintMultipleChallanAtal`, reqBody);
  }

  getApplicationsForMISubsidyLot(userId: String) {
    return this.http.get<any>(`${environment.apiUrl}Department/GetApplicationsForMISubsidyLot?UserId=${userId}`);
  }
  
  insertMISubsidyLot(reqBody){
    return this.http.post(`${environment.apiUrl}Department/InsertMISubsidyLot`, reqBody);
  }
  
  getApplicationsForPhysicalVerification(UserRid:any,AppType:any,FinancialYear:any){
    return this.http.get(`${environment.apiUrl}DashBoard/GetApplicationsForPhysicalVerification?UserId=${UserRid}&AppType=${AppType}&financialYear=${FinancialYear}`);
  }

  getActiveUserIDsByGeoCodes(userId:any){
    return this.http.get(`${environment.apiUrl}Department/GetActiveUserIDsByGeoCodes?UserId=${userId}`);
  }
  GetUhbvnNOCPathByXEN(userid:any){
    return this.http.get(`${environment.apiUrl}FarmerApplication/GetUhbvnNOCPathByXEN?userid=${userid}`);
  }

  getDataToPrintMultipleChallanAtal(userId: String) {
    return this.http.post(`${environment.apiUrl}Challan/GetDataToPrintMultipleChallanAtal?RequestType=${userId}`, {});
  }

  approveOtherUsersChallan(reqBody){
    return this.http.post(`${environment.apiUrl}Department/ApproveOtherUsersChallan`, reqBody);
  }

  getApplicationsForMIFarmerShareToVendorLot(userId: String) {
    return this.http.get<any>(`${environment.apiUrl}Department/GetApplicationsForMIFarmerShareToVendorLot?UserId=${userId}`);
  }
  getApplicationsForMISubsidyToVendorLot(userId: String) {
    return this.http.get<any>(`${environment.apiUrl}Department/GetApplicationsForMISubsidyToVendorLot?UserId=${userId}`);
  }

  getApplicationsForMISubsidyToFarmerLot(userId: String) {
    return this.http.get<any>(`${environment.apiUrl}Department/GetApplicationsForMISubsidyToFarmerLot?UserId=${userId}`);
  }

  getApplicationsForMISubsidyToFarmerLotIsAtal(userId: String) {
    return this.http.get<any>(`${environment.apiUrl}Department/GetApplicationsForMISubsidyToFarmerLot_Atal?UserId=${userId}`);
  }

  getApplicationsForMISubsidyToVendorLot_Atal(userId: String) {
    return this.http.get<any>(`${environment.apiUrl}Department/GetApplicationsForMISubsidyToVendorLot_Atal?UserId=${userId}`);
  }

  getApplicationsForMIRefundToFarmerLot(userId: String) {
    return this.http.get<any>(`${environment.apiUrl}Department/GetApplicationsForMIRefundToFarmerLot?UserId=${userId}`);
  }
  insertpondSubsidyLot(reqBody){
    return this.http.post(`${environment.apiUrl}Department/InsertPondSubsidyLot`, reqBody);
  }

  getDashboardIframeUrl(reqBody){
    return this.http.post(`${environment.apiUrl}DashBoard/GetDashboardIFrameURL`, reqBody);
  }

  //post
  postCountExportDataFrequency(reqBody){
    return this.http.post<any>(`${environment.apiUrl}Department/SaveMILotExportLog`, reqBody);
  }
  GetRealTimeDataofPDMCScheme() { 
    return this.http.get<any>(`${environment.apiUrl}DashBoard/MICanalTubewellApplication`);
  }
  GetMicroIrrigationSystem() {
    return this.http.get<any>(`${environment.apiUrl}DashBoard/GetPondCanalTubewellApplication`);
  }
  GetLineChartList() { 
    return this.http.get<any>(`${environment.apiUrl}DashBoard/GetCMDashboardYearWiseProgressMI`);
  }
  GetPieChartList() { 
    return this.http.get<any>(`${environment.apiUrl}DashBoard/GetCMDashboardYearWiseMIArea`);
  }
  getApplicationDataOfPreEstimation(appId, progId){
    return this.http.get<any>(`${environment.apiUrl}DashBoard/getApplicationDataOfPreEstimation?AppId=${appId}&ProgId=${progId}`);
  }
  
  getApplicationDataForPhysicalVer(autoId, userId){
    return this.http.get<any>(`${environment.apiUrl}DashBoard/GetApplicationDataForPhysicalVer?AutoId=${autoId}&UserId=${userId}`);
  }

  getDistWiseAvgTimeConsumed(){
    return this.http.get<any>(`${environment.apiUrl}Reports/GetDistWiseAvgTimeConsumed`);
  }

  getDistWiseAvgTimeConsumedProgram(reqBody){
    return this.http.get<any>(`${environment.apiUrl}Reports/GetDistWiseAvgTimeConsumedProgram?District=${reqBody.District}&Program=${reqBody.Program}`);
  }


  getWorkflowAllStatusByAppId(reqBody){
    return this.http.get<any>(`${environment.apiUrl}Reports/GetWorkflowAllStatusByAppId?AppId=${reqBody.AppId}&Program=${reqBody.Program}`);
  }

  getChallanPaymentDetails(appId: string){
    return this.http.get<any>(`${environment.apiUrl}Challan/ChallanPaymentDetails?AppId=${appId}`);
  }

  getOutletMasterForCanal(){
    return this.http.get<any>(`${environment.apiUrl}Department/GetOutletMasterForCanal`);
  }

  getCropMasterStatus(){
    return this.http.get<any>(`${environment.apiUrl}Department/GetCropMasterStatus`);
  }

  updateCropStatus(reqBody){
    return this.http.post<any>(`${environment.apiUrl}Department/UpdateCropStatus?CropId=${reqBody?.CropId}&Status=${reqBody?.Status}&DocumentPath=${reqBody?.documentPath}&documentID=${reqBody?.documentID}&fromDate=${reqBody?.fromDate}&endDate=${reqBody?.endDate}&Area=${reqBody?.area}&NetworkId=${reqBody?.NetworkId}&TerminalId=${reqBody?.TerminalId}`, {});
  }

  updateOutletStatus(reqBody){
    return this.http.post<any>(`${environment.apiUrl}Department/UpdateOutletStatus?AutoId=${reqBody?.AutoId}&Status=${reqBody?.Status}&DocumentPath=${reqBody?.documentPath}&documentID=${reqBody?.documentID}&fromDate=${reqBody?.fromDate}&endDate=${reqBody?.endDate}&Area=${reqBody?.area}&NetworkId=${reqBody?.NetworkId}&TerminalId=${reqBody?.TerminalId}`, {});
  }

  getAppIdByAadharNo(aadhar){
    return this.http.get<any>(`${environment.apiUrl}Department/GetAppIdByAadharNo?AadharNo=${aadhar}`, {});
  }

  getAppIdByAadharNoOrPhone(aadhar, mobile){
    return this.http.get<any>(`${environment.apiUrl}Vendor/GetBenificiarybyAadhaar?Aadhaar=${aadhar}&mobile=${mobile}`, {});
  }

  getOutletsForTarget(villageCode){
    return this.http.get<any>(`${environment.apiUrl}Department/GetOutletsForTarget?Village_Code=${villageCode}`, {});
  }

  addOutletToTarget(reqBody){
    return this.http.post<any>(`${environment.apiUrl}Department/AddOutletToTarget`, reqBody);
  }

  getOverflowPondMaster(){
    return this.http.get<any>(`${environment.apiUrl}Department/GetOverFlowPondMaster`);
  }

  updateOverFLowPondTargetStatus(reqBody){
    return this.http.post<any>(`${environment.apiUrl}Department/UpdateOverFLowPondTargetStatus?AutoId=${reqBody?.AutoId}&Status=${reqBody?.Status}&DocumentPath=${reqBody?.documentPath}&documentID=${reqBody?.documentID}&fromDate=${reqBody?.fromDate}&endDate=${reqBody?.endDate}&Area=${reqBody?.area}&NetworkId=${reqBody?.NetworkId}&TerminalId=${reqBody?.TerminalId}`, {});
  }

  addOverFlowPondToTarget(reqBody){
    return this.http.post<any>(`${environment.apiUrl}Department/AddOverFlowPondToTarget`, reqBody);
  }

  getAppLastStatus(reqBody){
    return this.http.post<any>(`${environment.apiUrl}Department/GetAppLastStatus`, reqBody);
  }

  addFarmerQueries(reqBody){
    return this.http.post<any>(`${environment.apiUrl}Department/AddFarmerQueries`, reqBody);
  }

  getFarmerQueriesActionMaster(){
    return this.http.get<any>(`${environment.apiUrl}Department/GetFarmerQueriesActionMaster`);
  }

  getSelectedProgram(reqBody: any){
    return this.http.post<any>(`${environment.apiUrl}Department/GetSelectedProgram`, reqBody);
  }

  getProgramToBeChanged(appId: any){
    return this.http.get<any>(`${environment.apiUrl}Department/GetProgramToBeChanged?AppId=${appId}`);
  }

  getMIConsolidatedFailedLotData(lotType: any, UserId: any){
    return this.http.get<any>(`${environment.apiUrl}Department/GetMIConsolidatedFailedLotData?LotType=${lotType}&UserId=${UserId}`);
  }

  getPondConsolidatedFailedLotData(Stage: any, UserId: any){
    return this.http.get<any>(`${environment.apiUrl}Department/GetPondConsolidatedFailedLotData?Stage=${Stage}&UserId=${UserId}`);
  }

  getMIFailedLotData(lotType: any, LotNo: any){
    return this.http.get<any>(`${environment.apiUrl}Department/GetMIFailedLotData?LotType=${lotType}&LotNo=${LotNo}`);
  }

  getPondFailedLotData(Stage: any, LotNo: any){
    return this.http.get<any>(`${environment.apiUrl}Department/GetPondFailedLotData?Stage=${Stage}&LotNo=${LotNo}`);
  }

  updateMIFailedLot(reqBody){
    return this.http.post<any>(`${environment.apiUrl}Department/UpdateMIFailedLot`, reqBody);
  }
  
  updatePondFailedLot(reqBody){
    return this.http.post<any>(`${environment.apiUrl}Department/UpdatePondFailedLot`, reqBody);
  }
  
  getAppsForReVerEPC(conId, userId){
    return this.http.get<any>(`${environment.apiUrl}Department/GetAppsForReVerEPC?ConId=${conId}&UserId=${userId}`);
  }
  
  getAppsForLotGenerationEPC(conId, userId, outlet){
    return this.http.get<any>(`${environment.apiUrl}Department/GetAppsForLotGenerationEPC?ConId=${conId}&UserId=${userId}&OutletId=${outlet}`);
  }

  getAppsForLotPFMSEPC(conId, userId){
    return this.http.get<any>(`${environment.apiUrl}Department/GetAppsForLotPFMSEPC?ConId=${conId}&UserId=${userId}`);
  }
  
  importLotsEPC(reqBody){ 
    return this.http.post<any>(`${environment.apiUrl}Department/ImportLotsEPC`, reqBody);
  }

  importEPCOfflinePayment(reqBody){ 
    return this.http.post<any>(`${environment.apiUrl}Department/ImportEPCOfflinePayment`, reqBody);
  }
  
  getAverageTimeConsumed(userId){
    return this.http.get<any>(`${environment.apiUrl}Dashboard/GetAverageTimeConsumed?UserId=${userId}`);
  }
  
  getAllUserRanking(){
    return this.http.get<any>(`${environment.apiUrl}Reports/GetAllUserRanking`);
  }
  
  getUserRankingByActionUser(userAction, userRole, userID){
    return this.http.get<any>(`${environment.apiUrl}Reports/GetUserRankingByActionUser?Action_Type=${userAction}&UserRole=${userRole}&UserID=${userID}`);
  }
  
  getAppIDAssignmentPlan(userId){
    return this.http.get<any>(`${environment.apiUrl}Department/GetAppIDAssignmentPlan?userid=${userId}`);
  }
  
  jeAssignSurveyPlan(reqBody){
    return this.http.post<any>(`${environment.apiUrl}Department/JeAssignSurveyPlan`, reqBody);
  }
  
  reAssignSurveyPlan(reqBody: any){
    return this.http.post<any>(`${environment.apiUrl}Department/ReAssignSurveyPlan`, reqBody);
  }

  getTargetsMIPond(progType){
    return this.http.get<any>(`${environment.apiUrl}Department/GetTargetsMIPond?ProgramType=${progType}`);
  }

  updateMIPondTarget(reqBody){
    return this.http.post<any>(`${environment.apiUrl}Department/UpdateMIPondTarget`, reqBody);
  }

  insertTarget(reqBody){
    return this.http.post<any>(`${environment.apiUrl}Department/InsertTarget`, reqBody);
  }
}
